import Tools from '@/components/tools/Tools'
import ActionsForm from '@/shared/mixins/actionsForm'

export default{
  name: 'paneldetailsdespesas',
  mixins: [ActionsForm],
  props: ['datadespesa', 'StatusNotEdit', 'usuarioGrupoDV'],
  data () {
    return {
      funcionarioVinculados: [],
      funcionarioarray: [],
      datadespesa: 0,
      datadespesaDiversos: 0
    }
  },
  watch: {
    datadespesa (newvalue) {
      this.datadespesaDiversos = newvalue
      this.verificafuncionario()
    }
  },
  mounted () {
    this.verificafuncionario()
    // this.GetDespesasDiversosbyid()
  },
  methods: {
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    nomeCurto (nome) {
      if (!nome) return ''
      let p = nome.trim().split(/\s+/)
      return p.length > 1 ? p[0] + ' ' + p[p.length - 1] : nome
    },
    returnFormatedData (value) {
      let data = new Date(value)
      let day = data.getDate()
      let month = data.getMonth() + 1
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }

      return `${day}/${month}/${data.getFullYear()}`
    },

    verificafuncionario () {
      this.funcionarioarray = this.datadespesaDiversos.funcionarioVinculados
      let funcionariocolaborador = this.datadespesaDiversos.funcionario.id

      this.funcionarioarray.forEach((e, index) => {
        if (e.funcionarioID === funcionariocolaborador) {
          const funcionarioLogado = this.funcionarioarray.find((funcionario) => {
            return funcionario.funcionarioID === funcionariocolaborador
          })
          this.funcionarioarray.splice(index, 1)
          this.funcionarioarray.unshift(funcionarioLogado)
        }
        this.datadespesaDiversos.funcionarioVinculados = this.funcionarioarray
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/paneldetailsdespesas/paneldetailsdespesas.js